import {
    Button,
    createButton,
} from '@vfde-brix/ws10/button';
import { nextChunk } from '../features/app/slice';
import { startAppListening } from '../app/listener';
import {
    selectDevicesToShow,
    selectIsLastChunk,
} from '../features/app/selectors';
import {
    store,
    useAppDispatch,
} from '../app/store';

/**
 * Mount button for chunking
 */
export const mountChunkingButton = (containerId: string): Button | null => {
    const buttonContainer = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!buttonContainer) {
        return null;
    }

    const button = createButton(buttonContainer, {
        onClick: (event: Event) => {
            event.stopPropagation();
            const dispatch = useAppDispatch();

            dispatch(nextChunk());
        },
    });

    const state = store.getState();
    const isLastChunk = selectIsLastChunk(state);

    // show or hide the button initially
    updateButtonState(
        button,
        isLastChunk,
    );

    listenForUpdates(button);

    return button;
};

const listenForUpdates = (button: Button) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectDevicesToShow(currentState) !== selectDevicesToShow(previousState),
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const isLastChunk = selectIsLastChunk(state);

            updateButtonState(
                button,
                isLastChunk,
            );
        },
    });
};

/**
 * Toggles visibility and disabled state of the button
 */
const updateButtonState = (
    button: Button,
    shouldHideButtonContainer: boolean,
): void => {
    button.toggleContainer(shouldHideButtonContainer);
};
